import { FieldErrors } from 'react-hook-form';

import { ErrorsNavigationService } from 'services/errorsNavigation/errorsNavigation';

import { getAllTaskErrors } from './utils';
import { TaskError } from './types';

export class TaskErrorsService extends ErrorsNavigationService<TaskError> {
  constructor() {
    super();
  }

  focusOnCurrentError = async (): Promise<void> => {
    //TODO: We don't need the focus on current error functionality. Maybe in the future
    throw new Error('Not needed yet');
  };

  processTaskErrors = (formErrors: FieldErrors, variables: Record<string, string>): void => {
    const errors = getAllTaskErrors(formErrors, variables);
    this.setErrors(errors);
  };
}
